<template>
  <div class="text-center">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li v-if="!simple" :class="{ disabled: pagination.current_page == 1 }" class="visible-md-inline visible-lg-inline">
          <a @click.prevent="changePage(1)" aria-label="First" :disabled="pagination.current_page == 1" title="Primeira">
            <span aria-hidden="true"><i class="fa fa-lg fa-angle-double-left"></i></span>
          </a>
        </li>
        <li v-if="!simple" :class="{ disabled: pagination.current_page == 1 }" class="pagination-previous">
          <a @click.prevent="changePage(pagination.current_page - 1)" aria-label="Previous" :disabled="pagination.current_page == 1" title="Anterior">
            <span aria-hidden="true"><i class="fa fa-lg fa-angle-left"></i></span>
          </a>
        </li>
        <li v-for="n in pagination.last_page" :class="{ active: n == pagination.current_page }">
          <a v-if="n >= min && n <= max" @click.prevent="changePage(n)">{{ n }}</a>
        </li>
        <li v-if="!simple" :class="{ disabled: pagination.current_page == pagination.last_page }" class="pagination-next">
          <a @click.prevent="changePage(pagination.current_page + 1)" aria-label="Next" title="Próxima">
            <span aria-hidden="true"><i class="fa fa-lg fa-angle-right"></i></span>
          </a>
        </li>
        <li v-if="!simple" :class="{ disabled: pagination.current_page == pagination.last_page }" class="visible-md-inline visible-lg-inline">
          <a @click.prevent="changePage(pagination.last_page)" aria-label="Last" title="Última">
            <span aria-hidden="true"><i class="fa fa-lg fa-angle-double-right"></i></span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'PaginationBootstrap',
    props: ['pagination', 'simple'],
    computed: {
      min () {
        let num = this.pagination.current_page - 3
        let maxMinAllowed = this.pagination.last_page - 6
        if (num < 1) return 1
        if (num > maxMinAllowed) return maxMinAllowed
        return num
      },
      max () {
        let num = this.pagination.current_page + 3
        return num < 7 ? 7 : num
      }
    },
    methods: {
      changePage (page) {
        if (page >= 1 && page <= this.pagination.last_page && page !== this.pagination.current_page) {
          this.$emit('paginated', page)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PaginationBootstrap.vue?f1a8bee2